var Marionette = require('backbone.marionette');

var RoleModel = require('../../models/role-model');

var RoleFormView = Marionette.View.extend({
    template: require('../../templates/roles/role-form.html'),

    regions: {
    },

    model: new RoleModel(),

    childViewEvents: {
    },

    ui: {
        saveBtn: '#save-role',
        roleName: '#name',
        roleType: '#type'
    },

    events: {
        'click @ui.saveBtn': 'addRole',
        'keyup @ui.roleName': 'validate',
        'change @ui.roleType': 'roleTypeSelected',
        'change #can-read': 'onChecked',
        'change #can-write': 'onChecked',
        'change #can-write-for': 'onChecked',
        'change #can-delete': 'onChecked',
        'change #can-sign': 'onChecked',
        'change #can-sign-all': 'onChecked',
        'change #can-upload-for': 'onChecked',
        'change #can-read-for': 'onChecked',
        'change #can-read-all': 'onChecked',
        'change #can-change-reviewer': 'onChecked',
        'change #can-edit-all': 'onChecked'
    },

    showOrganization: false,

    templateContext: function () {
        return {
        };
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'addRole',
            'afterUpdate', 'onChecked', 'validate', 'roleTypeSelected');
        if (options) {
        }
    },

    onRender: function () {
        this.$('#type').selectize({
            allowEmptyOption: false
        });
        this.initiateStates();
    },

    validate: function(event) {
        var value = event.target.value;
        this.model.set('templateName', value);
        if (value != '')
            this.ui.saveBtn.removeAttr("disabled");
        else
            this.ui.saveBtn.attr("disabled", "true");
    },

    initiateStates: function() {
        this.model.set(this.model.defaults);
        this.ui.saveBtn.attr("disabled", "true");
    },

    addRole: function () {
        this.model.save(this.model.toJSON(), {success: this.afterUpdate});
    },

    afterUpdate: function () {
        this.triggerMethod('role:saved', this.model.clone());
        this.model.set(this.model.defaults);
        this.render();
    },

    onChecked: function (event) {
        this.model.set(event.target.value, event.target.checked);
    },

    roleTypeSelected: function (event) {
        this.model.set('templateType', event.target.value);
    }
});

module.exports = RoleFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/roles/role-form.js
// module id = 447
// module chunks = 0